// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__26dmA","title":"styles_title__6NRqz"};